// Assembles e-mail addresses that the server delivers without an "@" (see src/Twig/MailLinkTwigExtension.php).
// Markup: data-mail-u / data-mail-d hold the reversed local part and domain. On a link the mailto href is set;
// the address becomes the text of the element itself or of its [data-mail-text] children.
const reverse = (value) => [...value].reverse().join('');

export default function initMailLinks(root = document) {
    root.querySelectorAll('[data-mail-u][data-mail-d]').forEach((element) => {
        const address = `${reverse(element.dataset.mailU)}@${reverse(element.dataset.mailD)}`;

        if ('A' === element.tagName) {
            element.setAttribute('href', `mailto:${address}`);
        }

        const textElements = [...element.querySelectorAll('[data-mail-text]')];
        if (element.hasAttribute('data-mail-text')) {
            textElements.push(element);
        }
        textElements.forEach((textElement) => {
            textElement.textContent = address;
        });

        element.removeAttribute('data-mail-u');
        element.removeAttribute('data-mail-d');
    });
}
